export default __webpack_public_path__ + "assets/schick_banner_1280x120-d573b56184c150e11901dece84c4a06e.jpg";